// @ts-nocheck
import React, { useState } from 'react';
import { styled } from '@mui/material/styles';
import Box from "@mui/material/Box";
import InicioDeAlias from "./InicioDeAlias";
import AlertMessage from "./AlertMessage";
import KeyCloak from "../Auth/Keycloak";
import { useAlias } from "./State/AliasContext";

const AliasConsulta = () => {
    return (
        <Box sx={{ paddingX: { xs: '20px', md: "40px" } }}>
            {KeyCloak.hasRole(["ROLE_OBTENER_ALIAS"]) ? <InicioDeAlias /> : null}
        </Box>
    );
};

export default AliasConsulta;
